import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-card-cedrow-with-tabel.js';

const buttonRivoneedHtml = buttonPrimaryHtml({
  text: 'Take advantage of the offer',
  backgroundColor: '#00374c',
  color: '#ffffff',
  radius: 100,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
});

const html = `
<div class="container wrap-card">
  <div data-attribute="card-title" data-show="true" class="card-title">
    <h2 style="text-align: center;">Lorem ipsum, dolor sit amet consectetur adipisicing elit.</h2>
  </div>
  <div class="wrap-table">
    <div data-attribute="table-editor" class="table-editor">
      <figure class="table">
        <table style="min-width: 700px">
          <thead>
            <tr>
              <th style="width: 500px">&nbsp;</th>
              <th style="width: 500px">Cedrow</th>
              <th style="width: 500px">
                <span style="color: rgb(44, 45, 46); font-size: 14.3822px">Rigid Plastic AFO</span>
              </th>
              <th style="width: 500px"><span style="font-size: 14.3822px">Surgery</span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="width: 500px"><strong>Comfort Level</strong></td>
              <td style="width: 500px">
                <span style="background-color: rgba(44, 45, 46, 0.03); color: rgb(44, 45, 46); font-size: 14.3822px"
                  >Lightweight &amp; Breathable</span
                >
              </td>
              <td style="width: 500px">
                <img src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbb3f5045794f6b544eb9.png?w=25&h=25" alt="" />
              </td>
              <td style="width: 500px">
                <img src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbb3f5045794f6b544eb9.png?w=25&h=25" alt="" />
              </td>
            </tr>
            <tr>
              <td style="width: 500px"><strong>Mobility</strong></td>
              <td style="width: 500px">
                <span style="background-color: rgba(44, 45, 46, 0.03); color: rgb(44, 45, 46); font-size: 14.3822px"
                  >Flexible Support</span
                >
              </td>
              <td style="width: 500px">
                <span style="background-color: rgba(44, 45, 46, 0.03); color: rgb(44, 45, 46); font-size: 14.3822px"
                  >Restricted Motion</span
                >
              </td>
              <td style="width: 500px">
                <img src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bbbb3f5045794f6b544eb9.png?w=25&h=25" alt="" />
              </td>
            </tr>
            <tr>
              <td style="width: 500px"><strong>Ease of Use</strong></td>
              <td style="width: 500px">
                <span style="background-color: rgba(44, 45, 46, 0.03); color: rgb(44, 45, 46); font-size: 14.3822px"
                  >Instant &amp; Simple</span
                >
              </td>
              <td style="width: 500px">
                <span style="background-color: rgba(44, 45, 46, 0.03); color: rgb(44, 45, 46); font-size: 14.3822px"
                  >Complex Fit</span
                >
              </td>
              <td style="width: 500px">
                <span style="background-color: rgba(44, 45, 46, 0.03); color: rgb(44, 45, 46); font-size: 14.3822px"
                  >Invasive Procedure</span
                >
              </td>
            </tr>
            <tr>
              <td style="width: 500px"><strong>Cost</strong></td>
              <td style="width: 500px">
                <span style="background-color: rgba(44, 45, 46, 0.03); color: rgb(44, 45, 46); font-size: 14.3822px"
                  >Affordable</span
                >
              </td>
              <td style="width: 500px">
                <span style="background-color: rgba(44, 45, 46, 0.03); color: rgb(44, 45, 46); font-size: 14.3822px"
                  >Expensive</span
                >
              </td>
              <td style="width: 500px">
                <span style="background-color: rgba(44, 45, 46, 0.03); color: rgb(44, 45, 46); font-size: 14.3822px"
                  >Very Expensive</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </figure>
    </div>
  </div>
  <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
</div>

`;

export default containerFuild(html, css, {
  backgroundColor: '#ffffff',
  textColor: '#00374c',
  topPadding: true,
  bottomPadding: true,
});
